import { useLayoutEffect, useRef } from 'react';

function usePermissions(permitPermissions = [], userPermissions = []) {
	const ref = useRef(null);

	useLayoutEffect(() => {
		let permit = permitPermissions.some((it) => userPermissions.includes(it));
		// permitPermissions.forEach((permission) => {
		// 	permit = permit && userPermissions.includes(permission);
		// });
		// permitPermissions.some((permission) =>
		// 	permit = permit && userPermissions.includes(permission);
		// );
		// if (!permit) {
		// 	ref.current.style.visibility = 'hidden';
		// } else {
		// 	ref.current.style.visibility = 'visible';
		// }
		if (!permit) {
			ref.current.style.display = 'none';
		} else {
			ref.current.style.display = 'flex';
		}

		return;
	}, [userPermissions, permitPermissions]);
	return ref;
}

export default usePermissions;
